import type { RequestStateQuery } from '../../@types/RequestStateQuery';
import Permissions from './Permissions';
import usePermissions from './usePermissions';
import { type PermissionResolved, resolvePermission } from './utils';

const usePermissionWebsite = (): [PermissionResolved | undefined, RequestStateQuery] => {
  const [permissions, request] = usePermissions();
  return [resolvePermission(permissions, Permissions.WebsiteEnabled), request];
};

export default usePermissionWebsite;
